<div *ngIf='show'>
  <h4 *ngIf='showHeading'>{{ 'GRANT_PASSAGE.TERMINAL' | translate }}</h4>
  <div *ngIf='terminal' class='terminal-container'>
    <app-status-led [terminal]='terminal'></app-status-led>
    <div class='terminal'>
      <span class='terminal-name'>{{ terminal.name }}</span>
      <span class='terminal-status {{terminalStatusColor()}}'>{{ terminal.status.name }}</span>
    </div>
  </div>
</div>
